module.exports = new Promise(async (resolve, reject) => {
      try {
        const module = await import('https://sn2-whiteboard-dev13.web.app/assets/remoteEntry.js?t=1751425315915');
        resolve(module);
      } catch (error) {
        // console.error('Failed to load remote:', error);
        resolve(null);
      }
    })
;